export default __webpack_public_path__ + "static/shaun-28263cae176bf1ff9bb1e536d83711bb.png";